var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0C44.7514 0 0 44.7514 0 100C0 144.199 28.6679 181.645 68.3855 194.905C73.3579 195.826 75.1995 192.756 75.1995 190.055C75.1995 187.661 75.1381 181.4 75.0767 173.051C47.2683 179.067 41.3751 159.669 41.3751 159.669C36.8324 148.128 30.264 144.997 30.264 144.997C21.1786 138.797 30.9392 138.92 30.9392 138.92C40.9454 139.656 46.2861 149.233 46.2861 149.233C55.1872 164.518 69.6746 160.098 75.3837 157.52C76.3045 151.074 78.8828 146.654 81.7066 144.138C59.5457 141.682 36.2185 133.088 36.2185 94.7821C36.2185 83.8551 40.0859 74.954 46.5316 67.9558C45.488 65.3775 42.0503 55.2486 47.4524 41.4979C47.4524 41.4979 55.8625 38.7968 74.954 51.7495C82.9343 49.5396 91.4672 48.4346 100 48.3732C108.471 48.4346 117.066 49.5396 125.046 51.7495C144.138 38.7968 152.548 41.4979 152.548 41.4979C158.011 55.2486 154.573 65.4389 153.53 67.9558C159.914 74.954 163.781 83.8551 163.781 94.7821C163.781 133.211 140.393 141.621 118.109 144.138C121.67 147.207 124.923 153.346 124.923 162.676C124.923 176.059 124.8 186.802 124.8 190.117C124.8 192.818 126.581 195.887 131.676 194.905C171.393 181.645 200 144.199 200 100.061C200 44.7514 155.249 0 100 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github_logo.0751427e3181629e8a7ea904ca834016.svg";
export { ForwardRef as ReactComponent };